module.exports = __webpack_public_path__ + "img/dca.97b892d3.jpg";